import { getElementsByXPath } from './utils'

const convertFontsToDataUrls = async (urls) => {
  const fontFetches = urls.map((url) => {
    return fetch(url).then((response) => {
      return new Promise((resolve) => {
        const reader = new FileReader()

        reader.onloadend = () => {
          resolve({
            url,
            base64: reader.result,
          })
        }

        response.blob().then((blob) => {
          reader.readAsDataURL(blob)
        })
      })
    })
  })

  return Promise.allSettled(fontFetches).then((responses) =>
    responses.filter((response) => response.status === 'fulfilled').map((response) => response.value)
  )
}

export default async ({ fonts }) => {
  try {
    const stylesheetUrls = Array.from(document.querySelectorAll('link[rel="stylesheet"]')).map((style) => style.href)
    const stylePromises = stylesheetUrls.map((stylesheetUrl) =>
      fetch(stylesheetUrl).then((response) => response.text())
    )
    let stylesheetsText = (await Promise.allSettled(stylePromises)).map((response) => response.value).join('\n')
    stylesheetsText += getElementsByXPath("//style[contains(text(),'@font-face')]")
      .map((sheet) => sheet.innerText)
      .join('\n')

    const fontFaces = stylesheetsText.match(/@font-face\s?{.*?}/gs).flatMap((fontFace) => {
      const urls = fontFace.match(/url\(.*?\)/g).map((url) => url.replace(/^url\(('|"?)/, '').replace(/\)$/, ''))
      return fontFace.match(/font-family:.*?;/g).map((fontFamily) => ({
        family: fontFamily
          .toLowerCase()
          .replace(/^font-family:\W?('|"?)/, '')
          .replace(/('|"?);$/, ''),
        text: fontFace,
        urls,
      }))
    })

    if (!fontFaces.length) {
      return ''
    }

    const fontsToConvert = fontFaces.filter((font) => fonts.includes(font.family))
    const conversions = await convertFontsToDataUrls(fontsToConvert.flatMap((font) => font.urls))
    return conversions.reduce(
      (css, { base64, url }) => css.replace(url, base64),
      fontsToConvert.flatMap((font) => font.text).join('\n')
    )
  } catch (error) {
    return ''
  }
}
